const actions = {
    GET_PLAID_DATA: "GET_PLAID_DATA",
    LOADING: "LOADING",

    loading: () => {
        return {
            type: actions.LOADING
        }
    }
};

export default actions;
